import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '[&>div>div]:px-20px [&>div>div]:py-19.5px relative w-full',
    button: 'group disabled:text-inactive size-6 bg-transparent p-0',
    icon: 'group-pressed:-scale-100 group-hover/sort:[&>path]:stroke-brand-400 size-[24px] transition-transform duration-150',
    input: 'text-base font-light'
  },
  variants: {
    noInput: {
      true: {
        input: 'cursor-pointer'
      }
    }
  }
});
